'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_28f16a69 = {"avatar":"Avatar_module_avatar__de810618","size-20":"Avatar_module_size20__de810618","size-28":"Avatar_module_size28__de810618","size-36":"Avatar_module_size36__de810618","size-44":"Avatar_module_size44__de810618","size-52":"Avatar_module_size52__de810618","size-60":"Avatar_module_size60__de810618","image":"Avatar_module_image__de810618","group":"Avatar_module_group__de810618"};
require("../../../assets/cjs/components/Avatar/src/Avatar~D__CkPqh.css");

exports.default = modules_28f16a69;
//# sourceMappingURL=Avatar.module.less.js.map
